import type { CoachingReportType } from "../services/coaching-dtos";

export const reportTypeLabels: Record<CoachingReportType, string> = {
  team_admin: "Team / company",
  coach_feedback: "Coach",
  vjal_internal: "VJAL internal",
  ceo_confidential: "CEO confidential"
};
